module.exports = __webpack_public_path__ + "static/media/regiao_centro-oeste.cc070d84.svg";